import { JSX, useEffect, useState } from "react";
import "./UserNavbar.scss";
import { Link, useNavigate, useLocation } from "react-router-dom";
import type { MenuProps } from 'antd';
import { BackendAPI } from "../../axios";
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  FileOutlined,
  MailOutlined, CustomerServiceOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
  HomeOutlined , AccountBookFilled,
  InfoCircleFilled,
  InfoCircleOutlined
} from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import { Breadcrumb, Layout, Menu, theme, Button, Tooltip, } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
  { key: 'user/homepage', icon: <HomeOutlined />, label: 'Home' },
  {
    key: 'my_acc',
    label: 'My Account',
    icon: <MailOutlined />,
    children: [
      { key: 'user/resetPassword', label: 'Change Password' },
      { key: 'user/update_profile', label: 'Update Profile' },
      // { key: 'user/logout', label: 'logout' },
    ],
  },
  {
    key: 'my_services',
    label: 'My Services',
    icon: <AppstoreOutlined />,
    children: [
      { key: 'user/ipwhitelisting', label: 'IP Whitelisting' },
      { key: 'user/txnsummary', label: 'Transactions Summary', style: { lineHeight: 'normal', whiteSpace: 'pre-wrap' } },
      { key: 'user/cost_summary', label: 'Cost Summary' },
    ],
  },
  {
    key: 'helpDesk',
    label: 'Help Desk',
    icon: <AppstoreOutlined />,
    children: [
      { key: 'user/newTicket', label: 'New Ticket' },
      { key: 'user/viewTicket', label: 'View Ticket', style: { lineHeight: 'normal', whiteSpace: 'pre-wrap' } },
      // { key: 'user/cost_summary', label: 'Cost Summary' },
    ],
  },
  
  ];
function NavBar(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState('');
  const [defaultOpenKey, setDefaultOpenKey] = useState('');
  
  const [time, setTime] = useState(() => {
    const INITIAL_TIME = Number(localStorage.getItem('initialTime'));
    const savedTime = localStorage.getItem("remainingTime");
    const savedTimestamp = localStorage.getItem("lastSavedTime");
    if (savedTime && savedTimestamp) {
      const elapsed = Math.floor((Date.now() - Number(savedTimestamp)) / 1000);
      const remaining = Math.max(Number(savedTime) - elapsed, 0);
      return remaining > 0 ? remaining : INITIAL_TIME / 1000;
    }
    return INITIAL_TIME / 1000; 
  });

  
  const onClick = (e: { key: string; }) => {
    if (e.key === 'user/homepage') {
      setSelectedKey(e.key);
      navigate('/user/homepage');
    }
    if (e.key === 'user/newTicket') {
      setSelectedKey(e.key);
      navigate('/user/newTicket')
    }
    if (e.key === 'user/viewTicket') {
      setSelectedKey(e.key);
      navigate('/user/viewTicket')
    }
  
    if (e.key === 'user/resetPassword') {
      setSelectedKey(e.key);
      navigate('/user/resetPassword');
    }
    if (e.key === 'user/update_profile') {
      setSelectedKey(e.key);
      navigate('/user/update_profile');
    }
    if (e.key === 'user/ipwhitelisting') {
      setSelectedKey(e.key);
      navigate('/user/ipwhitelisting');
    }
    if (e.key === 'user/txnsummary') {
      setSelectedKey(e.key);
      navigate('/user/txnsummary');
    }
    if (e.key === 'user/cost_summary') {
      setSelectedKey(e.key);
      navigate('/user/cost_summary');
    }
    if(e.key === 'user/logout') {
      setSelectedKey(e.key);
      localStorage.clear();
      handleLogout();
    }
  }

  const handleLogout = async () => {
    try {
      const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

      if (response.status === 200) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("initialTime");
        localStorage.removeItem("lastSavedTime");
        localStorage.removeItem("remainingTime");
        navigate("/");
      }
    } catch (error) {
    }
  };

  const handleLogoutSessionTimeout = async () => {
    try {
      const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

      if (response.status === 200) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("initialTime");
        localStorage.removeItem("lastSavedTime");
        localStorage.removeItem("remainingTime");
        localStorage.setItem('sessionTimeoutMessege', 'true');
        navigate("/");
        // toast.error(
        //       "Your session has timed out. Please log in again to continue.",
        //       {
        //         position: "top-center",
        //         autoClose: 5000,
        //         hideProgressBar: true
        //       }
        //     );
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    const urlLocaltion = location.pathname;
    urlLocaltion == '/' ? 
    setSelectedKey('home') : setSelectedKey('user' + urlLocaltion.split('/user')[1]);
// OpenKey
    
  }, []);
  
  useEffect(() => {
    // Save current time remaining and timestamp
    localStorage.setItem("remainingTime", time.toString());
    localStorage.setItem("lastSavedTime", Date.now().toString());

    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer); // Clear interval when time is up
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [time]);
  const formatTime = (time: number) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    if(minutes == '00' && seconds == '00') {
      localStorage.clear();
      handleLogoutSessionTimeout();
    }
    return `${minutes}:${seconds}`;
  };
  
  return (
    <>
{/* <Button></Button> */}

        <Menu onClick={onClick}  theme={'light'} className="user-navbar-left"
        selectedKeys={[selectedKey]} mode="inline" items={items} 
        defaultOpenKeys={[defaultOpenKey]}
        />
      <div style={{ position: 'fixed', bottom: '55px', zIndex: '1000',
        textAlign: 'center', left: '2px'
       }}>
        {/* <Button type="primary" style={{display:'block'}}>
          Time left: {formatTime(time)}
        </Button> */}
        {/* <div style={{border: '2px solid red', fontSize: '16px', borderRadius: '5px',width: '178%' }}>
        Time left: {formatTime(time)}
        </div> */}
      </div>
    </>
  );
}

export default NavBar;
